/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateClinicDto } from '../../models/create-clinic-dto';
import { ResponseClinicDto } from '../../models/response-clinic-dto';

export interface ClinicsControllerCreate$Params {
      body: CreateClinicDto
}

export function clinicsControllerCreate(http: HttpClient, rootUrl: string, params: ClinicsControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseClinicDto>> {
  const rb = new RequestBuilder(rootUrl, clinicsControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseClinicDto>;
    })
  );
}

clinicsControllerCreate.PATH = '/thalea-clinics/clinics';
